import { SET_ROOT_DIRECTORY } from '../actions/types';

export default function rootDir(state = {}, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_ROOT_DIRECTORY:
				return action.payload;
			// no default
		}
	}

	return state;
}
